import React from 'react'
import { IconType } from 'react-icons';

interface bluebutton {
  label: string;
  icon?: IconType;
  onClick?: any;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
}
const BlueOutlinedButton: React.FC<bluebutton> = ({ loading, label, icon: Icon, onClick, className, disabled }) => {
  return (
    <button disabled={loading||disabled} onClick={onClick} className={className ? 'generate-outlined-btn w-full md:w-auto h-[45px] ' + className : 'generate-outlined-btn w-full md:w-auto h-[45px] '} >
      <div className='flex justify-center items-center gap-3 mx-auto text-[#007BFF] text-[15px]'>
        {Icon && <Icon style={{ strokeWidth: "1.5px" }} />}
        {label}</div>
    </button>
  )
}

export default BlueOutlinedButton